vec3 effect(vec2 uv)
{
    vec2 p = uv - 0.5;
    float angle = atan(p.y, p.x);
    float radius = length(p);
    float segments = 3.0 + floor(uAmount * 9.0);
    float slice = 6.2831853 / segments;
    angle = mod(angle + uTime * 0.2, slice);
    angle = abs(angle - slice * 0.5);
    return sampleCam(vec2(cos(angle), sin(angle)) * radius + 0.5);
}
